<template>
    <div class="row page-row users">
        <div class="d-flex justify-content-center mb-3" v-if="!company">
            <b-spinner label="Loading..." variant="danger"></b-spinner>
        </div>

        <div class="col-sm-12 pr-4" v-else>
            <!-- Header Section -->
            <slot name="header">
                <b-button
                    :disabled="!canAddUser"
                    variant="danger"
                    @click="$emit('create-user')"
                    ref="btnShow"
                    v-if="showAddButton"
                >
                    <b-icon icon="plus" variant="md"></b-icon>
                    {{ addButtonText }}
                </b-button>
                <div v-else>
                    You have maxed out your user limit, please contact <a href="mailto:support@dotag.com">support@dotag.com</a>
                </div>
            </slot>

            <br/>
            <br/>

            <!-- Table Section -->
            <table class="table table-hover users">
                <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">User</th>
                    <th scope="col">
                        Role
                        <b-button
                            variant="none"
                            size="md"
                            pill
                            style="padding: 0;margin: 0;"
                            @click="$emit('show-roles-info')"
                        >
                            <b-icon icon="info"
                                    class="rounded-circle bg-danger text-white text-decoration-none"></b-icon>
                        </b-button>
                    </th>
                    <th scope="col">Last updated</th>
                    <th class="col-6" scope="col">Assigned to</th>
                    <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                    <template v-for="user in users">
                        <tr :class="{
                            'table-dark opacity-50': user.is_deleted
                        }">
                            <th scope="row">{{ user.unique_id }}</th>
                            <td>{{ user.name }}</td>
                            <td>{{ user.role ? user.role.name : '-' }}</td>
                            <td>
                                    <span class="last-updated" v-b-tooltip :title="$options.filters.moment(user.updated_at, 'DD.MM.YYYY HH:mm')">
                                        {{ formatLastUpdated(user.updated_at) }}
                                    </span>
                            </td>
                            <td>
                                    <span v-for="(project,index) in user.assigned_projects" v-bind:key="'p_' + index">
                                        {{ project.name }}<span v-if="index !== user.assigned_projects.length - 1">, </span>
                                    </span>
                            </td>
                            <td>
                                <button
                                    v-if="canEditUser(user)"
                                    class="btn edit"
                                    @click="$emit('edit-user', user)"
                                ></button>
                                <template v-if="canDeleteUser(user)">
                                    <button
                                        v-if="!user.is_deleted"
                                        class="btn delete"
                                        @click="$emit('delete-user', user)"
                                    ></button>
                                    <button
                                        v-else
                                        class="btn restore"
                                        @click="$emit('restore-user', user)"
                                    ></button>
                                </template>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <slot name="modals"></slot>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'UsersTable',

    props: {
        addButtonText: {
            type: String,
            default: 'Add User',
        },
        company: {
            type: Object,
            required: false,
            default: null
        },
        users: {
            type: Array,
            required: true,
            default: () => []
        },
        canAddUser: {
            type: Boolean,
            default: false
        },
        canEditUser: {
            type: Function,
            required: true
        },
        canDeleteUser: {
            type: Function,
            required: true
        },
        maxUsers: {
            type: Number,
            default: 10
        },
    },

    computed: {
        showAddButton() {
            const activeUserCount = this.users.filter(user => !user.is_deleted).length;
            return this.company && this.maxUsers > activeUserCount
        }
    },

    methods: {
        formatLastUpdated(date) {
            return moment(date).fromNow()
        }
    }
}
</script>
